import styled, { css } from "styled-components";

import base from "@/themes/base/base";

import { calculateIsGrey800Variant, calculateIsPrimaryVariant } from "@/types/filters";
import type { SearchBarVariant } from "@/types/search-bar";

interface SearchBarStylingProps {
    variant: SearchBarVariant;
    width?: string;
    focus?: boolean;
}

export const SearchBarWrapperDiv = styled.div.withConfig({
    shouldForwardProp: (prop) => !["focus", "variant"].includes(prop),
})<SearchBarStylingProps>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    width: ${({ width }) => (width ? `${width}` : "18.25rem")};
    border-radius: 2px;
    padding: 0.4375rem 0.75rem;
    border: 1px solid transparent;

    background-color: ${({ variant }) => {
        const isGrey800Variant = calculateIsGrey800Variant(variant);

        return isGrey800Variant ? base.colors.neutral.grey[800] : base.colors.neutral.grey[900];
    }};

    & input {
        ${({ variant }) => {
            const isPrimaryVariant = calculateIsPrimaryVariant(variant);

            return isPrimaryVariant
                ? base.typography.smallRegular
                : base.typography.extraSmallRegular;
        }};

        color: ${base.colors.neutral.grey[50]};
        background-color: transparent;
        border: none;
        outline: none;
        width: 100%;

        &::placeholder {
            color: ${base.colors.neutral.grey[500]};
        }
    }

    &:hover {
        ${({ focus }) =>
            !focus &&
            css`
                border: 1px solid ${base.colors.neutral.grey[300]};
            `}
    }

    ${({ focus, theme }) =>
        focus &&
        css`
            border: 1px solid ${theme.colors.primary.orange[500]};
        `}
`;

export const IconWrapper = styled.div`
    display: flex;
`;
